/*
 * Copyright © 2024. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { RefObject } from "react";
import { withScroll } from "@/src/services/withScroll";
import { Fab, Fade } from "@mui/material";
import { ArrowUpwardRounded } from "@mui/icons-material";

type ScrollTopButtonProps = {
  scrollPosition: number;
  /* TODO: Check every layout and check if skip can be implemented, then remove optional */
  skipLinkRef?: RefObject<HTMLAnchorElement | null>;
};

const ScrollTopButton = ({ scrollPosition, skipLinkRef }: ScrollTopButtonProps) => {
  return (
    <Fade in={scrollPosition >= 300} timeout={1000}>
      <Fab
        color={"primary"}
        aria-label={"Zurück zum Anfang der Seite springen"}
        sx={{
          position: "fixed",
          bottom: "70px",
          right: "10vw",
        }}
        onClick={() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          skipLinkRef?.current?.focus({ preventScroll: true });
        }}
      >
        <ArrowUpwardRounded />
      </Fab>
    </Fade>
  );
};

export default withScroll(ScrollTopButton);
